import { render, staticRenderFns } from "./NYCXCustomDashboard.vue?vue&type=template&id=3dccd86e"
import script from "./NYCXCustomDashboard.vue?vue&type=script&lang=ts"
export * from "./NYCXCustomDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports